<template>
   <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">
      </div>
    </template>

    <template #customLayoutContent>
      <div class="m-10">
        <Card  containerClass="mb-5">
          <div class="card-header">
            <div class="card-title"> {{$t('breadcrumbs.contracts.liste')}} </div>
            <div class="card-toolbar" >
              <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_EMPLOYEE_CONTRACT)" type="new" btn-text="contract.add"  @click="openCreateModal"/>
            </div>
          </div>
          <template #cardBody>
            <table class="table align-middle table-row-bordered fs-6 gy-3 gx-4" id="kt_datatable_contracts" style="margin-top: 13px !important; cursor:pointer">
              <thead style="background-color: #F2F3F4;">
              <tr class="fw-bold fs-6" style="background-color: #F2F3F4;">
                <th class=" px-4 ">{{$t("contract.employe")}}</th>
                <th class=" px-4 ">{{$t("contract.type")}}</th>
                <th class=" px-4 ">{{$t("contract.duration")}}</th>
                <th class=" px-4 ">{{$t("contract.salaire")}}</th>
                <th class=" px-4 ">{{$t("contract.active")}}</th>
                <th>{{$t("actions")}}</th>
              </tr>
              </thead>
            </table>
          </template>    
        </Card>

        <UpdateContractModal id="edit_contract_modal" :formEdit="formEdit" @reloadDatatable="reloadDatatable" />
        <NewContractModal id="create_contract_modal" @reloadDatatable="reloadDatatable" />
        <FilesAttachModal id="file_attached" :files="file"/>

      </div>
    </template>
    </SubLayout>
</template>

<script setup>

import {ref,onMounted,watch , nextTick} from "vue";
import {BASE_URL} from "@/services/api";
import {useStore} from "vuex";
import Ls from "@/services/ls";
import { useI18n } from 'vue-i18n'
import { useLocales } from '@/composables/locales';
import Button from "@/components/Button.vue";
import Card from "@/Modules/CRM/components/Card";
import {Theme} from "@/composables/theming";
import {useSwal} from "@/composables/useSwal";
import {useHasAbility} from "@/composables/hasAbility";
import { useFormatAmount } from "@/composables/formatAmount";
import UpdateContractModal from "./components/UpdateContractModal.vue";
import NewContractModal from "./components/NewContractModal.vue";
import { computed } from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import abilities from "@/composables/abilities";
import FilesAttachModal from "@/components/FilesAttachModal.vue";

const title = ref("breadcrumbs.contracts.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.contracts.liste',
    path: '/contracts'
  }
])

const table = ref(null)
const formEdit = ref({})
const file = ref([])

const store = useStore()

const { t } = useI18n({ useScope: 'global' })
const {locale, datatableLocaleUrl} = useLocales()
const {showSwal} = useSwal()
const { can } = useHasAbility()
const { formatAmount } = useFormatAmount()

const currentSociety = computed(() => store.getters['offices/getSelectedCompany'])


function openCreateModal(){
  $('#create_contract_modal').modal('toggle')
}

function openEditModal(){
  $('#edit_contract_modal').modal('toggle')
}

function fetchDatas() {
      const AUTH_TOKEN = Ls.get('auth.token')
      const society = Ls.get('current.company')
      const pageLimit = Ls.get('pageLength')

      table.value = $("#kt_datatable_contracts").DataTable({
        destroy : true,
        responsive: !0,
        searchDelay: 500,
        processing: !0,
        serverSide: !0,
        pageLength:pageLimit ||  5,
        lengthMenu: [5, 10, 25, 50, 75, 100 ],
        order: [[ 0, 'desc']],
        ajax: {
          url: BASE_URL + `/get/employee/contract/datatables?society_id=${society}`,

          type: "GET",
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
            request.setRequestHeader("Company", Ls.get('current.company'));
            },
          data:  function ( d ) {

          }
        },
        columns: [{data: "employee_name"},{data: "contract_type"},{data: "start_date"},{data: "salary"},{data: "is_active"}, {data: "Actions", responsivePriority: -1}],

        columnDefs: [
        {
              targets: -6,
              orderable: !1,
              render:  (t, a, e, l) =>  {
                return '<span class="nameRow' + l.row + '">' + t + "</span>";
              },
          },
          {
              targets: -5,
              orderable: !1,
              render:  (t, a, e, l) =>  {
                return '<span class="nameRow' + l.row + '">' + t?.toUpperCase() + "</span>";
              },
          },
          {
              targets: -4,
              orderable: !1,
              render:  (t, a, e, l) =>  {
                return '<span>'+ e.start_date + ' - '+ e.end_date + '  </span>';
              },
          },
          {
              targets: -3,
              orderable: !1,
              className: "dt-center clickable",
              render:  (t, a, e, l) =>  {
                return '<span class="nameRow' + l.row + '">' + formatAmount(t) + "</span>";

              }
          },

          {
              targets: -2,
              orderable: !1,
              className: "dt-center clickable",
              render:  (t, a, e, l) =>  {
                  return '<span class="nameRow' + l.row + '">' + t ? i18n.global.t("label.yes") : i18n.global.t("label.no") + "</span>";
              }
          },

          {
            width: "16%",
            targets: -1,
            "className": "dt-center",
            title: "Actions",
            orderable: !1,
            render: (t, a, e, l) => {
              let render = '';
              if(can(abilities.DOWNLOAD_CONTRACT_EMPLOYEE_CONTRACT)) render += ` <a href="javascript:;" data-row="${l.row}"
                data-id="${e.id}" data-file='${e.file}' data-url='${e.file_url}' class="btn btn-sm btn-clean btn-icon view_btn" title="${i18n.global.t('button.view')}"><i data-row="${l.row}" data-id="${e.id}" data-file='${e.file}' data-url='${e.file_url}' class="fas fa-eye fs-2" style="color: ${Theme.gray}"></i></a>
              <a href="javascript:;" data-row="${l.row}"
                data-id="${e.id}" data-end="${e.end_date}" data-employee_name="${e.employee_name}" data-start="${e.start_date}"
                class="btn btn-sm btn-clean btn-icon download_btn" title="${i18n.global.t('button.download')}"><i data-row="${l.row}" data-id="${e.id}" data-end="${e.end_date}" data-employee_name="${e.employee_name}" data-start="${e.start_date}" class="fas fa-download fs-2" style="color: ${Theme.gray}"></i></a>`;

              if(can(abilities.UPDATE_EMPLOYEE_CONTRACT)) render += `<a href="javascript:;"
                   data-row="${l.row}" 
                   data-id="${e.id}" 
                   data-type="${e.contract_type}"  
                   data-society_id="${e?.society_id}"  
                   data-start='${e.start_date}' 
                   data-end='${e.end_date}' 
                   data-notes='${e.notes}' 
                   data-salary='${e.salary}' 
                   data-employee_id='${e.employee_id}' 
                   data-file='${e.file}'
                   class="btn btn-sm btn-clean btn-icon edit_btn" 
                   title="${i18n.global.t('button.edit')}">
                   <i data-row="${l.row}" 
                       data-id="${e.id}" 
                      data-type="${e.contract_type}"  
                      data-society_id="${e?.society_id}"  
                      data-start='${e.start_date}' 
                      data-end='${e.end_date}' 
                      data-notes='${e.notes}' 
                      data-salary='${e.salary}' 
                      data-employee_id='${e.employee_id}'
                      data-file='${e.file}'
                      class="fas fa-edit fs-2"  
                      style="color: ${Theme.gray}"></i> 
                </a>`;

              if(can(abilities.DELETE_EMPLOYEE_CONTRACT)) render += `<a href="javascript:;" data-row="${l.row}" data-id="${e.id}" class="btn btn-sm btn-clean btn-icon delete_btn" title="${i18n.global.t('button.delete')}"><i data-row="${l.row}" data-id="${e.id}" class="fas fa-trash fs-2" style="color: ${Theme.gray}"></i></a>`;
              return render;
            },
          },

        ],
        language: {
          url:  datatableLocaleUrl.value
        }
      });

      $(document).on("click", "#kt_datatable_contracts .edit_btn", (e) => {
        formEdit.value.id = e.target.getAttribute('data-id')
        formEdit.value.society_id= e.target.getAttribute('data-society_id') ?? currentSociety.value?.id,
        formEdit.value.contract_type = e.target.getAttribute('data-type')
        formEdit.value.start_date = e.target.getAttribute('data-start')
        formEdit.value.end_date = e.target.getAttribute('data-end')
        formEdit.value.notes = e.target.getAttribute('data-notes')
        formEdit.value.salary = e.target.getAttribute('data-salary')
        formEdit.value.employee_id = e.target.getAttribute('data-employee_id')
        formEdit.value.file = e.target.getAttribute('data-file')

        openEditModal()

      });
}

function reloadDatatable(){
  table.value.ajax.reload()
}

$(document).on("click", "#kt_datatable_contracts .download_btn", (e) => {
  let data = {
    id: e.target.getAttribute('data-id'), 
    name: e.target.getAttribute('data-employee_name') + '_' + e.target.getAttribute('data-start') + '_' + e.target.getAttribute('data-end') + '.pdf'
  }
  downloadContract(data)
});

$(document).on("click", "#kt_datatable_contracts .delete_btn", (e) => {
  deleteContract(e.target.getAttribute('data-id'))
});

$(document).on("click", "#kt_datatable_contracts .view_btn", (e) => {
  file.value = [{file_url: e.target.getAttribute('data-url'), file: e.target.getAttribute('data-file') }]
  $('#file_attached').modal('toggle')
});


async function deleteContract(id){
  showSwal(
      t('swal.contract'),
      t('swal.contract_text')
  ).then( async (result) => {
    if (result.value) {
      try {
        await store.dispatch('contracts/deleteContract', id)
        reloadDatatable()
        window.toastr.success(t('notification.contract_deleted'))
      } catch (e) {
      }
    }
  });
}

async function downloadContract(id){
  try {
        await store.dispatch('contracts/downloadContract', id)
        reloadDatatable()
        window.toastr.success(t('notification.contract_downloded'))
      } catch (e) {
      }
}

const fetchEmployees = ()=>{
  if(currentSociety.value){
    store.dispatch("offices/loadSocietyEmployee", currentSociety.value?.id)
  }
}
watch(() => currentSociety.value, () => {
  fetchEmployees()
})

watch(() => locale.value, () => {
  nextTick(()=>   fetchDatas())
})

onMounted(() => {
  const society = Ls.get('current.company')
  fetchEmployees()
  store.dispatch("contracts/loadContractTypeEnum")
  store.dispatch('offices/loadOfficesBySocieties')
  if(society){
    fetchDatas()
  }

})

</script>
<style>
.end{
  display: flex;
  justify-content: end;
}
</style>